import { createFileRoute } from "@tanstack/react-router";

// /my-page のインデックスルート。
// 本体は layout route（my-page.tsx）の MyProfileTemplate が担う。
export const Route = createFileRoute("/_authenticated/my-page/")({
  component: () => null,
});
